/**
 * Handler widget type for data
 */
export enum EComponentType {
  /**
   * Handler for shift selection
   */
  shift = 0,
  /**
   * Handler for chart type
   */
  chart = 1,
  /**
   * Handler for table type
   */
  table = 2,
  // TODO generar para componentes custom
  /**
   * Other handler type
   */
  machineStatusByShift = 3,
  machineStatus = 4,
  statusByMachine = 5,
  perforationsByMachine = 6,
  statusFront = 7,
  productionByHour = 9,
  statusSummary = 8,
  productionByFront = 10,
  operationalDiscipline = 11,
  statusByMachineGroup = 12,
  trainMinuteByMinute = 15,
  loopsByTrain = 13,
  StatusByMachineTableComponent = 14,
  loopsByServiceTrain = 16,
  transitLoopsBzn = 17,
  lhdLoopsHours = 18,
  ProductionEveryThirtyMinutesComponent = 19,
  totalExtraction = 20,
  productionByMachine = 21,
  productionByOperator = 22,
  productionByStreet = 23,
  statusPark = 24,
  minuteByminute = 25,
  totalCharge = 26,
  dumpPoints = 27,
  truckTypeDumpPoint = 28,
  productionTonsByHour = 29,
  generalDrilling = 30,
  loopScoop = 31,
  drillActivityType = 32,
  productionvsPlan = 33,
  productionByChimney = 34,
  tonsByOrigin = 35,
  loopsByOrigin = 36,
  productionByHourTruck = 37,
  productionByHourDayTruck = 38,
  productionByModelTruckDump = 39,
  DelayTimeTruckEmbedded = 40,
  ProductionByTruckAndTolva = 41,
}
